<script lang="ts">
  import { Table } from "sveltestrap";
  import { href } from "../../../utils/Constant/Constant";
  import FeatherIcons from "svelte-feather-icon";
  import data from "../../../Data/Tasks/Tasks.json"
  import Link from "svelte-link";
  import {tasksManage} from "../../../store"
  tasksManage.update(value => value = data.createdtasksdata)
  let setTasksManage:any
  tasksManage.subscribe((value)=>{
    setTasksManage = value
  })
  //  for tasks delete
  const handleRemove = (getValue) => {
    tasksManage.update(value => value = setTasksManage.filter((data:any)=> data != getValue))
  }
</script>
<div class="taskadd">
    <div class="table-responsive">
      <Table>
          {#each setTasksManage as taskItem}
              <tr>
                  <td>
                    <h6 class="task_title_0">{taskItem.title}</h6>
                    <p class="project_name_0">{taskItem.name}</p>
                  </td>
                  <td>
                      <p class="task_desc_0">{taskItem.task}</p>
                  </td>
                  <td>
                    <Link class="me-2" href={href}>
                        <FeatherIcons icon="link" />
                    </Link>
                    <Link href={href}>
                        <FeatherIcons icon="more-horizontal" />
                    </Link>
                  </td>
                  <td>
                    <Link href={href} on:click={()=>handleRemove(taskItem)}>
                        <FeatherIcons icon="trash-2" />
                    </Link>
                  </td>
              </tr>
          {/each}
      </Table>
    </div>
</div>